// // scroll bar
import 'simplebar/src/simplebar.css';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import UserContext from './Contexts/UserContext';
import ProductContext from './Contexts/ProductContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ProductContext>
    <UserContext>
      <HelmetProvider>
        <HashRouter hashType="hashbang">
          <App />
        </HashRouter >
      </HelmetProvider>
    </UserContext>
  </ProductContext>
);

// If you want to enable client cache, register instead.
// serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
